/** Imports */
import ReactCanvasConfetti from 'react-canvas-confetti/dist/presets/fireworks';


/** Component */
export default function Confetti() {
    return (
        <ReactCanvasConfetti
            autorun={{speed: 1}}
            style={{
                position: 'fixed',
                zIndex: 2,
                pointerEvents: 'none',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
            }}
        />
    );
}
